import { z } from "zod"

import {
  cleanupCustomRegexesMax,
  cleanupCustomWordsMax,
  cleanupRegexMaxLength,
  type DescriptionCleanupConfig,
} from "./description-cleanup.js"

/**
 * The persisted shape of a workspace's cleanup config. The
 * workspace_cleanup_configs.config column is jsonb with the shape enforced
 * where written, the way workflow conditions are, and this schema is that
 * enforcement: the API routes validate request bodies through it and the
 * repository parses stored rows through it, so the two cannot drift.
 *
 * Syntax and backtracking safety of custom regexes are a separate check
 * (validateCleanupRegex) run at save time; the schema only bounds size.
 */
export const DescriptionCleanupTogglesSchema = z
  .object({
    removeDates: z.boolean(),
    removeCurrencyValues: z.boolean(),
    removePhoneNumbers: z.boolean(),
    removeStateCodes: z.boolean(),
    removeHashNumbers: z.boolean(),
    replacePunctuationWithSpaces: z.boolean(),
    removeSpecialCharacters: z.boolean(),
    removeNumbersInWords: z.boolean(),
    collapseSpaces: z.boolean(),
    removeShortNumbers: z.boolean(),
  })
  .strict()

export const DescriptionCleanupConfigSchema = z
  .object({
    toggles: DescriptionCleanupTogglesSchema,
    shortNumberMaxDigits: z.number().int().min(1).max(9),
    customWords: z
      .array(z.string().trim().min(1).max(80))
      .max(cleanupCustomWordsMax),
    customRegexes: z
      .array(z.string().min(1).max(cleanupRegexMaxLength))
      .max(cleanupCustomRegexesMax),
  })
  .strict() satisfies z.ZodType<DescriptionCleanupConfig>
